import React from "react";
import { Link, useLocation } from "react-router-dom";

const PATH_LABELS = {
  portal: "Dashboard",
  appointment: "Appointments",
  allpatient: "Patients",
  addpatient: "Add Patient",
  patientprofile: "Patient Profile",
  employeelist: "Staff",
  addemployee: "Add Staff",
  employeeprofile: "Staff Profile",
  "salary-management": "Salary Management",
  "device-manager": "Biometric Device Manager",
  "leave-management": "Leave Management",
  "group-sessions": "Group Sessions",
  invoice: "Invoices",
  income: "Income",
  expense: "Expenses",
  payment: "Payment",
  paymentHistory: "Payment History",
  billing: "Billing",
  "pricing-plans": "Pricing Plans",
  attendance: "Attendance",
  settlement: "Monthly Settlement",
  services: "Services",
  "session-types": "Session Types",
  designations: "Designations",
  "waiting-list": "Waiting List",
  rolelist: "Roles",
  addrole: "Add Role",
  "predictive-intelligence": "Insights",
  "revenue-forecast": "Revenue Forecast",
  "dropout-risk": "Dropout Risk",
  "therapist-performance": "Therapist Performance",
  "business-advisor": "Business Advisor",
  "therapy-intelligence": "Therapy Intelligence",
  profile: "Settings",
  "login-history": "Login History",
  "change-password": "Change Password",
  "clinic-details": "Clinic Details",
  "business-hours": "Business Hours",
  "appointment-settings": "Appointment Settings",
  "tax-settings": "Tax Settings",
  "invoice-settings": "Invoice Settings",
  "integration-settings": "Google Calendar & Meet",
  guests: "Guest Sessions",
  "wallet-credits": "Wallet Credits",
  referrals: "Referrals",
  branding: "Branding",
  preferences: "Preferences",
  "help-support": "Help & Support",
  "plan-checkout": "Subscription",
  notifications: "Notifications",
  settings: "Settings",
};

const Breadcrumbs = () => {
  const { pathname, search } = useLocation();

  // Skip breadcrumbs on dashboard home
  if (pathname === "/portal" || pathname === "/portal/") return null;

  const segments = pathname.replace(/^\/portal\/?/, "").split("/").filter(Boolean);
  if (segments.length === 0) return null;

  // Detect edit mode from query params
  const params = new URLSearchParams(search);
  const hasId = params.get("id") || params.get("UserId");

  // Build breadcrumb items
  const crumbs = [{ label: "Dashboard", path: "/portal" }];
  let currentPath = "/portal";

  for (const seg of segments) {
    currentPath += `/${seg}`;
    let label = PATH_LABELS[seg] || seg.replace(/-/g, " ").replace(/(^|\s)\S/g, (c) => c.toUpperCase());
    // Show "Edit" instead of "Add" when editing
    if (hasId && label.startsWith("Add ")) {
      label = label.replace("Add ", "Edit ");
    }
    crumbs.push({ label, path: currentPath });
  }

  return (
    <nav className="flex items-center gap-1 text-xs text-content-tertiary mb-1">
      {crumbs.map((crumb, i) => (
        <React.Fragment key={crumb.path}>
          {i > 0 && (
            <svg className="w-3 h-3 opacity-40 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          )}
          {i < crumbs.length - 1 ? (
            <Link to={crumb.path} className="hover:text-brand-500 transition-colors">
              {crumb.label}
            </Link>
          ) : (
            <span className="text-content-secondary font-medium">{crumb.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

const PageHeader = ({ title, subtitle, action, className = "", hideBreadcrumbs = true }) => (
  <div className={`page-header ${className}`}>
    <div>
      {!hideBreadcrumbs && <Breadcrumbs />}
      <h1 className="page-title">{title}</h1>
      {subtitle && <p className="page-subtitle">{subtitle}</p>}
    </div>
    {action && <div className="flex items-center gap-2">{action}</div>}
  </div>
);

export default PageHeader;
